import YouTubeVideo from "@atoms/players/YouTubeVideo";
import { ArticleNonParagraphProps } from "@routes/Article/components/ArticleParagraphElements/utils/types";
import { cn } from "@util/helpers";
import parse, { DOMNode, Element } from "html-react-parser";

/**
 * Renders a Brightcove video element in an article.
 * This component processes the body string to extract the video ID and renders the Brightcove player.
 */
const InlineYoutube = ({
  bodyString,
  className,
  paragraphWidth,
}: ArticleNonParagraphProps): React.ReactElement => {
  const transformVideo = (
    node: DOMNode
  ): string | boolean | void | object | Element | null => {
    if (node.type === "tag" && node.name === "iframe") {
      const el = node;

      const src = el.attribs["src"];
      const title = el.attribs["title"] || "Embedded YouTube Video";

      return (
        <YouTubeVideo
          src={src}
          className={cn("mb-6", className, paragraphWidth)}
          title={title}
        />
      );
    }
  };

  return (
    <div data-testid="article-inline-youtube-component">
      {parse(bodyString, { replace: transformVideo })}
    </div>
  );
};

export default InlineYoutube;
